import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { TWebsiteBuilderSectionType } from "../../nodes/section/websiteBuilderSection";
import { faTableLayout } from "@fortawesome/pro-regular-svg-icons";
import { IWebsiteBuilderNodeMetadata } from "../nodeMetadata/websiteBuilderNodeMetadata";

type TWebsiteBuilderSectionMetadata = Record<TWebsiteBuilderSectionType, IWebsiteBuilderNodeMetadata>;

export function useWebsiteBuilderSectionMetadata(): TWebsiteBuilderSectionMetadata {
  const { t } = useTranslation();

  const sectionMetadata: TWebsiteBuilderSectionMetadata = useMemo(() => ({
    "header": { title: t("Header"), icon: faTableLayout },
    "content": { title: t("Section"), icon: faTableLayout },
    "footer": { title: t("Footer"), icon: faTableLayout },
  }), []);

  return sectionMetadata;
}